import {AfterContentInit, Component, ElementRef, Input, OnDestroy, ViewChild, inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from '@angular/common';

import type {Direction, GapSnap} from './marquee.types';
import {MarqueeDomService} from './services/marquee-dom.service';
import {MarqueeEngineService} from './services/marquee-engine.service';

@Component({
  selector: 'app-marquee',
  standalone: true,
  templateUrl: './marquee.component.html',
  styleUrls: ['./marquee.component.scss'],
  providers: [MarqueeEngineService, MarqueeDomService],
  host: {
    '[class.is-server]': 'isServer',
  },
})
export class MarqueeComponent implements AfterContentInit, OnDestroy {
  private _pauseOnHover = true;
  private _isPlaying = true;
  protected isServer = !isPlatformBrowser(inject(PLATFORM_ID));

  private engine = inject(MarqueeEngineService);

  @Input() set speed(v: number) {
    this.engine.speed = v ?? 80;
  }

  @Input() set direction(v: Direction) {
    this.engine.direction = v ?? 'left';
  }


  @Input()
  get pauseOnHover(): boolean {
    return this._pauseOnHover;
  }

  set pauseOnHover(v: boolean) {
    this._pauseOnHover = v;
    this.engine.pauseOnHover = v;
  }

  @Input()
  get isPlaying(): boolean {
    return this._isPlaying;
  }

  set isPlaying(v: boolean) {
    this._isPlaying = v;
    this.engine.isPlaying = v;
  }

  get isPaused() {
    return this.engine.isPaused;
  }

  @Input() set gap(v: number) {
    this.engine.gap = v ?? 32;
  }

  @Input() set autoFill(v: boolean) {
    this.engine.autoFill = v;
  }

  @Input() set updateVisible(v: boolean) {
    this.engine.updateVisible = v;
  }

  @Input() set gapSnap(v: GapSnap) {
    this.engine.gapSnap = v ?? 'smooth';
  }

  @ViewChild('wrapper', {static: true}) wrapperRef!: ElementRef<HTMLDivElement>;
  @ViewChild('aEl', {static: true}) aElRef!: ElementRef<HTMLDivElement>;
  @ViewChild('bEl', {static: true}) bElRef!: ElementRef<HTMLDivElement>;
  @ViewChild('pool', {static: true}) poolRef!: ElementRef<HTMLDivElement>;
  @ViewChild('source', {static: true}) sourceRef!: ElementRef<HTMLDivElement>;


  pause() {
    this.engine.pause();
  }

  resume() {
    this.engine.resume();
  }

  ngAfterContentInit(): void {
    this.engine.wrapperEl = this.wrapperRef.nativeElement;
    this.engine.aEl = this.aElRef.nativeElement;
    this.engine.bEl = this.bElRef.nativeElement;
    this.engine.poolEl = this.poolRef.nativeElement;
    this.engine.sourceEl = this.sourceRef.nativeElement;
    this.engine.init();
  }

  ngOnDestroy(): void {
    this.engine.destroy();
  }
}
